import { IEnclosure } from './enclosure.model';
import { IAdditionalBOMentries } from './additionalBOMEntries.model';
import { ISortModel } from './sort.model';

export interface ISavedState {
  savedState: number;
  isNewProject: boolean;
  isCurrent: number;
  id: number;
}

export interface IProject extends ISavedState, ISortModel {
  email: string;
  projectName: string;
  projectDescription: string;
  street: string;
  clientFirstName: string;
  contactPerson?: string;
  created: string;
  lastModified: string | Date;
  clientPostalCode: number;
  clientCity: string;
  phoneNumber: string;
  countryCode: string;
  projectId: number;
  userId?: number;
  enclosures: IEnclosure[];
  additionalBomEntries: IAdditionalBOMentries[];
  remarks: string;
  isFavorite: ProjectFavoriteColor | 0;
  files: IAssociateFileUpload[];
  lang: string;
  isShared?: boolean;
  projectOwner?: ProjectUser;
  projectMembers?: IProjectUserMember[];
  companyAdmins?: ProjectUser[];
  fileSizeLimitMB: number;
  fileSizeUsedMB: number;
  canEditProject?: boolean;
  isProjectNewAfterReassigning: boolean;
  installationDate?: string | Date;
  isArchived: boolean;
  shareWithinCompany?: boolean;
  isInTenderingMode: boolean;
}

export interface ProjectUser {
  id: number;
  firstName: string;
  lastName: string;
  avatar: string;
  email: string;
  canEditProject?: boolean;
}

export interface IProjectUserMember extends ProjectUser {
  memberViaShareWithinCompany: boolean;
}

export interface ISharedProject extends IProject {
  token?: string;
}

export interface IProjectsStats {
  projects: number;
  shared: number;
  pending: number;
  companyAssigned: number;
  companyUnassigned: number;
  archivedProjects: number;
  companyArchivedProjects: number;
}

export interface IAssociateFileUpload {
  projectId: number;
  fileName: string;
  fileSize: string;
  mimeType: string;
  encodedData: string;
  spimProjectId: string;
  fileId: number;
  dateCreated: Date;
  isSelected: boolean;
  savedFileName: string;
}

export interface ICompanyAdminsOfProjects {
  companyAdmins: ProjectUser[];
  assignedProjectsIds: number[];
}

export enum EnclosureTabType {
  CONFIGURATION = 0,
  DISPOSITION = 1
}

export interface IUpdateDeviceWithConflict {
  conflict: boolean;
}

export enum CompanyProjectTables {
  'ASSIGNED',
  'UNASSIGNED',
  'ARCHIVED'
}

export enum ProjectTablesType {
  MY_PROJECTS,
  SHARED_PROJECTS,
  COMPANY_PROJECTS,
  ARCHIVED_PROJECTS,
  COMPANY_ARCHIVED_PROJECTS,
}

export enum ProjectFavoriteColor {
  GREEN = 1,
  YELLOW = 2,
  ORANGE = 3,
  RED = 4
}

export interface IFavoriteProject {
  project: IProject,
  color: ProjectFavoriteColor | 0
}
